import { Button, Stack } from "@mui/material";
import { Colors } from "Components/Layout/Themes/Colors";
import { formatCurrency } from "Utils/CurrencyUtils";

type Props = {
  presets: ReadonlyArray<number>;
  currencyCode?: string;
  onSelect: (amount: number) => void;
};

export const AmountPresetButtons = ({
  presets,
  currencyCode,
  onSelect,
}: Props) => (
  <Stack direction="row" gap={1}>
    {presets.map((amount) => (
      <Button
        key={amount}
        onClick={() => onSelect(amount)}
        disableElevation
        sx={({ palette }) => ({
          flex: 1,
          height: 48,
          minWidth: 0,
          padding: "10px",
          borderRadius: "6px",
          fontSize: 14,
          fontWeight: 500,
          lineHeight: "20px",
          textTransform: "none",
          backgroundColor: palette.common.white,
          border: `1px solid ${Colors.Border}`,
          color: palette.common.black,
          "&:hover": {
            backgroundColor: Colors.BackgroundGrey,
            border: `1px solid ${palette.primary.main}`,
          },
        })}
      >
        {formatCurrency({ amount, currencyCode })}
      </Button>
    ))}
  </Stack>
);
